import React from 'react';
import {FaCheckDouble,FaCheck,FaTimes,FaLock} from 'react-icons/fa';
import {BiCabinet} from 'react-icons/bi';
import PropTypes from 'prop-types';
export const QrMatchCameraText = ({scanStatus, text, type})=>{
	return(
		<>

				<div className="fade-in text-center">
					{!scanStatus.includes("Invalid")
						? (scanStatus.includes("Match")
								? <h4 className="text-success"><FaCheckDouble/> {scanStatus} {text}</h4>
								: <h4 >{scanStatus!== ""?<FaCheck/>:false}  {scanStatus} {text}{type && (type === 'locker' ? <BiCabinet/> : <FaLock/>)} </h4>
							)
						: <h4 className="text-danger"><FaTimes/> {scanStatus}</h4>
					}
					<h5>Scan QR code on <BiCabinet/> or <FaLock/></h5>
				</div>




		</>
	)
}
QrMatchCameraText.propTypes = {
	scanStatus: PropTypes.string,
	screen:PropTypes.object,
	type: PropTypes.string,
	text: PropTypes.string,
};
